import React from 'react';
import { Star } from 'lucide-react';
import CrudManager from './CrudManager';
import { adminApi } from '../../lib/api';

const TESTIMONIAL_FIELDS = [
  { name: 'name', label: 'Client Name', required: true },
  { name: 'event', label: 'Event Type', required: true, placeholder: 'e.g. Wedding, Corporate Event' },
  {
    name: 'rating',
    label: 'Rating',
    type: 'select',
    options: [
      { value: 5, label: '5 stars' },
      { value: 4, label: '4 stars' },
      { value: 3, label: '3 stars' },
      { value: 2, label: '2 stars' },
      { value: 1, label: '1 star' },
    ],
  },
  { name: 'text', label: 'Testimonial Text', type: 'textarea', required: true, rows: 4 },
  { name: 'date', label: 'Date', placeholder: 'e.g. 2 weeks ago' },
  { name: 'order', label: 'Display Order', type: 'number' },
  { name: 'published', label: 'Publish on homepage', type: 'checkbox', checkboxLabel: 'Show this testimonial publicly' },
];

const TestimonialsAdmin = () => (
  <CrudManager
    title="Testimonials"
    description="Customer reviews displayed on the homepage"
    api={adminApi.testimonials}
    fields={TESTIMONIAL_FIELDS}
    itemLabel="Testimonial"
    renderItem={(item) => (
      <div>
        <div className="flex items-center gap-3 mb-2">
          <h3 className="text-[#EADBC8] font-bold">{item.name}</h3>
          <span className="text-xs text-[#C5A880]">{item.event}</span>
          <div className="flex">
            {[...Array(item.rating || 5)].map((_, i) => (
              <Star key={`${item.id}-star-${i}`} size={12} className="text-[#C5A880] fill-[#C5A880]" />
            ))}
          </div>
        </div>
        <p className="text-gray-300 text-sm italic line-clamp-2">"{item.text}"</p>
        <p className="text-gray-400 text-xs mt-2">
          {item.date} · Order: {item.order} · {item.published
            ? <span className="text-green-400">Published</span>
            : <span className="text-amber-400">Hidden (not on homepage)</span>}
        </p>
      </div>
    )}
  />
);

export default TestimonialsAdmin;
